// extracted by mini-css-extract-plugin
export default {"container":"not-allowed_container__dLzpb","content":"not-allowed_content__EXcOu","title":"not-allowed_title__i8Kfy"};